var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center text-center",staticStyle:{"height":"50vh"}},[_c('div',[_c('font-awesome-icon',{staticStyle:{"font-size":"96px","color":"#dddddd"},attrs:{"icon":"times-circle"}}),_c('div',{staticClass:"mt-4 text-info"},[_vm._v("404 页面未找到")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }